import { Button, Grid, useDisclosure } from '@chakra-ui/react'
import type { OfferTravel } from 'BrokerTsLib/src/dtos'

import type { SortBy } from '@/context/OffersProvider'
import { Container } from '../../components/Container'
import { useCestovkoOffersContext } from '../../context/CestovkoOffersProvider'
import { OfferCestovkoProvider } from '../../context/OfferCestovkoContext'
import { baseUrl } from '../../hooks'
import { useUpdateInsuranceStartDate } from '../../hooks/useWizard'
import { Duplicate } from '../../icons'
import { useInsuranceParamsContext } from '../../layouts/Wizard'
import { NewInsuranceVariantWrapper } from '../cestovko/NewInsuranceVariantWrapper'
import ExtraInsuranceCestovkoModal from '../ExtraInsuranceCestovkoModal'
import { FormButtons } from '../FormButtons'
import { OfferCestovkoGrid } from './grid/OfferCestovkoGrid'
import { OffersToolbar } from './OffersToolbar'

const insuranceParamsApiUrl = import.meta.env.VITE_INSURANCEPARAMS_TRAVEL_API
const insuranceParamsUrl = `${baseUrl}/${insuranceParamsApiUrl}`

export const OfferCestovkoCompare = ({ onCompareClick, setOrderFunc }: {
  onCompareClick?: Function,
  setOrderFunc?: (order: SortBy) => void
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { insuranceParams, insuranceParamsId, refetchInsuranceParams } = useInsuranceParamsContext()
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  const { offers, recalculateOffers, showAll, setShowAll, sortBy, setSortBy: changeSortBy, updateOffer } = useCestovkoOffersContext()
  const { mutateAsync: updateInsuranceStartDate } = useUpdateInsuranceStartDate(insuranceParamsId!)

  const cloneUrl = `${baseUrl}/cestovko/wizard/1`

  return (
    <Grid sx={{ gap: 8 }}>
      <OfferCestovkoProvider onCompareClick={() => onCompareClick && onCompareClick()}>
        <Container>
          <OffersToolbar
            offers={offers}
            editable={!insuranceParams?.generalParams.contractNumber}
            showAll={showAll}
            onSettingsClick={onOpen}
            setShowAll={setShowAll}
            onSetStartDate={(date: Date) => {
              return updateInsuranceStartDate(date)
                .then(() => {
                  recalculateOffers()
                  refetchInsuranceParams() // aby se updatnul header
                })
            }}
            sortBy={sortBy}
            changeSortBy={(sortBy) => {
              changeSortBy(sortBy)
              setOrderFunc?.(sortBy)
            }}
            updateOffer={(offer) => updateOffer(offer as OfferTravel)}
          />
        </Container>

        <OfferCestovkoGrid />
      </OfferCestovkoProvider>

      {insuranceParams && !isContracted &&
        <Container>
          <NewInsuranceVariantWrapper />
        </Container>
      }

      <FormButtons
        leftButtons={
          <Button variant="outline"
            as='a'
            href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(cloneUrl)}`}
          >
            <Duplicate color="secondary.500" />
            Klonovat
          </Button>
        }
      />

      {insuranceParams && <ExtraInsuranceCestovkoModal isOpen={isOpen} onClose={onClose} />}
    </Grid>
  )
}